module.exports = __webpack_public_path__ + "static/media/n-invite-colored.11fa1f3c.svg";